// import "scripts/wdyr";

// import * as lightrun from "lightrun";
// import "./wdyr";
import { GlobalStyle } from "styles/theme";
import "styles/globals.css";
import "allotment/dist/style.css";
import "react-js-cron/dist/styles.css";
import "@react-awesome-query-builder/antd/css/styles.css";
import "@react-awesome-query-builder/antd/css/compact_styles.css";

import { SWRConfig } from "swr";
import type { AppProps } from "next/app";

import CustomContexts from "components/Templates/CustomContexts";

import { DevSupport } from "@react-buddy/ide-toolbox";
import { ComponentPreviews, useInitial } from "dev";
import { useSWRCache } from "hooks/useSWRCache";
import GoogleAnalytics from "./GoogleAnalytics";
import ReactGA from "react-ga4";
function MyApp({ Component, pageProps }: AppProps<{}>) {
  useSWRCache();
  if (process.env.NODE_ENV === "production") {
    process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS &&
      ReactGA.initialize(process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS);
  }

  return (
    <SWRConfig>
      <CustomContexts>
        <GlobalStyle />

        {/* {process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS ? (
          <GoogleAnalytics ga_id={process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS} />
        ) : null}{" "} */}
        <DevSupport
          ComponentPreviews={ComponentPreviews}
          useInitialHook={useInitial}>
          <Component {...pageProps} />
        </DevSupport>
      </CustomContexts>
    </SWRConfig>
  );
}

export default MyApp;
